import React, { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Card, IconButton, CardMedia, Box, TableHead } from "@mui/material";
import { CustomBtn } from "../../../../components/button/button";
import html2canvas from 'html2canvas';
import { useSelector } from "react-redux";
import { Height } from "@mui/icons-material";
 import '../sales.scss'
const PrintBillDialog = ({ open, onClose, paymentData }) => {
    // //console.log(paymentData?.customer_contact)
    // //console.log(paymentData     )
    const loginUser = localStorage.getItem('loggedInUser')
    let phoneNumber = '';

    if (paymentData?.customer_contact == undefined) {
        let phone = paymentData?.customers[0]?.phone_number?.trim() || '';
        // Remove leading zero if present
        phone = phone.replace(/^0+/, '');
        phoneNumber = '93' + phone;
    } else {
        let phone = paymentData?.customer_contact?.trim() || '';
        // Remove leading zero if present
        phone = phone.replace(/^0+/, '');
        phoneNumber = '93' + phone;
    }
    // //console.log(Number(phoneNumber))
    // const billContentElement = document.getElementById('bill-content');
        const api = useSelector((state) => state.Api); 
        const billContentRef =  useRef(null);

        const handlePrint = () => {
            const printWindow = window.open('', '', 'width=600,height=600');
            const content = billContentRef.current?.innerHTML; // Get the content from the ref
            //console.log(content)
            if (content) {
              printWindow.document.write(`
                        <html>
                        <head>
                            <title>Bill</title>
                            <style>
                            @page {
                                size: 180mm auto;
                                margin: 0;           /* <<< remove page margin */
                            }
                            body {
                                margin: 0 !important;
                                padding: 0 !important;
                                width: 180mm;        /* ensures no squeezing */
                            }
                            #bill-content {
                                width: 100%;
                            }
                            </style>
                        </head>
                        <body>${content}</body>
                        </html>
                    `);

              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
            } else {
              console.error('No content to print.');
            }
          };
        
          
    const sendBillToWhatsApp = () => {
        const billContentElement = document.getElementById('bill-content');
    
        if (!billContentElement) {
            console.error("Bill content not found!");
            return;
        }
    
        // Capture the bill content as an image
        html2canvas(billContentElement, {
            scale: 1, 
            width: billContentElement.scrollWidth, // Capture full width
            height: billContentElement.scrollHeight, // Capture full height
            windowWidth:  billContentElement.scrollWidth, // Capture full width
            windowHeight:  billContentElement.scrollHeight, // Capture full height
         }).then((canvas) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Failed to convert canvas to blob");
                    return;
                }
                //console.log(billContentElement.scrollHeight, billContentElement.scrollWidth)
                // Prepare form data for image upload
                const formData = new FormData();
                formData.append("image", blob, "bill.png");
        
                // Upload the image to the backend server
                fetch(api.uploadBills, {
                    method: "POST",
                    body: formData,
                })
                .then((response) => response.json())
                .then((data) => {
                    // //console.log(data.imagePath);
                    if (!data.imagePath) {
                        throw new Error("Image upload failed");
                    }
        
                    const uploadedImageUrl = data.imagePath.replace(/\\\\/g, '\\'); // Replace double backslashes with a single backslash
                    const formattedPhoneNumber = Number(phoneNumber);
                    //console.log(uploadedImageUrl);
        
                    const whatsappLink = `https://wa.me/${formattedPhoneNumber}?text=${encodeURIComponent(
                        `${uploadedImageUrl}`
                        // ` *Check your bill here:*\n\n${uploadedImageUrl}`
                    )}`;
        
                    // Open WhatsApp with the message
                    window.open(whatsappLink, "_blank");
                })
                .catch((error) => {
                    console.error("Error uploading image:", error);
                });
            }, "image/png");
        }).catch((error) => {
            console.error("Error capturing bill:", error);
        });
        
    };
    
const currentDate = () => {
    if (!paymentData?.created_at) return '--';

    const date = new Date(paymentData.created_at);
    if (isNaN(date.getTime())) return '--';

    return new Intl.DateTimeFormat(
        'fa-AF-u-ca-persian',
        {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            calendar: 'persian'
        }
    ).format(date);
};



    const currentTime = () => {
    if (!paymentData?.created_at) return '--';

    const date = new Date(paymentData.created_at);
    if (isNaN(date.getTime())) return '--';

    return date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
};


    const handleThermalPrinter = () => {
        const { ipcRenderer } = window.require('electron');
        ipcRenderer.invoke('print-receipt', {
            items: [
            { name: "Coffee", qty: 2, price: 5.00 },
            { name: "Sandwich", qty: 1, price: 8.50 }
            ],
            total: 18.50
        }).then(result => {
            if (result.success) {
            //console.log('Print successful');
            } else {
            console.error('Print failed:', result.error);
            }
        });
        };
        return (
            <Dialog open={open} onClose={onClose}> 
                <DialogContent>
                <div id="bill-content" ref={billContentRef}  style={{ width: '300px', padding: '10px', backgroundColor: 'white' }}>
                    <Box style={{textAlign:'center'}}>
                        {/* <image style={{width:'200px', height:'80px'}} src={logo} /> */}
                    </Box> 
                    {/* <Box style={{textAlign:'center'}}></Box>  */}
                    <Box style={{textAlign:'center'}}><h2 style={{ margin:'0px',maxWidth:'290px'}}>{localStorage.getItem('businessName')}</h2></Box> 
                    <Box style={{textAlign:'center'}}><h2 style={{ margin:'0px',maxWidth:'290px', marginBottom:'15px', fontSize: '13px'}}>{localStorage.getItem('businessPhone')}</h2></Box> 
                    {/* <Box><p className='loanOrcash' style={{marginLeft:'20%'}}>{paymentData?.payment_method === 'LOAN'? 'پور': 'نغد'}</p></Box>  */}
                    <Box><p>Recipt #: {paymentData?.transaction_id}  <span style={{fontSize:'18px', marginLeft:'20px', fontWeight:'bold'}}>{paymentData?.payment_method === 'LOAN'? 'پور': 'نغد'}</span></p></Box> 
                    <Box>
                        <table style={{width:'290px'}}>
                            <tr>
                                <td style={{textAlign:'left', direction:'rtl'}}>تاریخ</td>
                                <td style={{textAlign:'left', direction:'rtl'}}>{currentDate()}</td>
                                <td colSpan={2} style={{textAlign:'right', direction:'ltr'}}>{currentTime()} وخت</td>
                            </tr>
                        </table>

                    </Box> 
                        <table style={{width:'290px'}}>
                            <thead>
                                <tr className="boldi">
                                    <td  style={{width:'150px'}}>Item</td>
                                    <td style={{width:'40px'}}>Price</td>
                                    <td style={{width:'40px'}}>Qty</td>
                                    <td style={{width:'50px'}}>Amount</td>
                                </tr>
                            </thead>
                        
                        {paymentData?.inCartProducts?.map((product, key) => ( 
                            <>
                            <tbody>
                                <tr>
                                <td style={{width:'150px'}}>{product?.product_id}</td>
                                <td style={{width:'40px'}}>{product?.selling_price}</td>
                                <td style={{width:'40px', textAlign:'center'}}>{product?.quantity_sold || product?.stock_quantity}</td>
                                <td style={{width:'50px'}}>{(parseInt(product?.selling_price) * parseInt(product?.quantity_sold || product?.stock_quantity))}</td>
                                </tr>
                                <tr>
                                    <td colSpan={product?.discount > 0 ? 2 : 4} className="boldi prodName" style={{width:'290'}}>{key+1}){product?.product_name}</td>
                                    {product?.discount > 0 ? <>
                                    <td style={{width:'40px'}}>Dis: </td>
                                    <td style={{width:'50px'}}>{(product?.discount)}</td>
                                    </> : null}
                                </tr>
                            </tbody> 
                            </>
                        ))} 
                        {paymentData?.discount_amount > 0? 
                        <tr>
                            <td>Discount</td>
                            <td></td>
                            <td></td>
                            <td>{paymentData?.discount_amount.toFixed(2)} </td>
                        </tr>
                        : null }
                        <tr className="boldi total">
                            <td style={{fontWeight:'bold', borderTop:'2px solid black'}}>Total</td>
                            <td style={{fontWeight:'bold', borderTop:'2px solid black'}}></td>
                            {/* <td>{paymentData?.inCartProducts?.reduce((acc, product) => acc + ( product?.quantity_sold), 0)}</td> */}
                            <td style={{fontWeight:'bold',borderTop:'2px solid black', textAlign:'center'}}>
                                {paymentData?.inCartProducts?.reduce(
                                (sum, item) => sum + Number(item.stock_quantity || item.quantity_sold || 0),
                                0
                                )}                                
                            </td> 
                            {/* <td>{(paymentData?.inCartProducts?.reduce((acc, product) => acc + (product?.selling_price * product?.quantity_sold) - (paymentData?.discount_amount), 0))?.toFixed(2)}</td> */}
                            <td style={{fontWeight:'bold', borderTop:'2px solid black'}}>{paymentData?.total_amount}</td>
                        </tr>
                              
                        <tfoot>
                            <tr>
                                <td colSpan={3}>SalesPerson: {loginUser}</td>
                            </tr>
                            <tr>
                                <td style={{textAlign:'center'}} className="pashtoThanks" colSpan={4}>ستاسو د راتګ څخه مننه</td>
                            </tr>
                            <tr>                                
                                <td colSpan={4}>Wasily Technology <b>www.Wasily.net</b></td>
                            </tr>
                        </tfoot>
                    </table> 
                    </div>
                </DialogContent>
                <Grid container lg={12} className='bottomTotal'>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={onClose} color="primary" variant="contained">OK</Button>
                            {/* <Button onClick={handleThermalPrinter} color="primary" variant="contained">OK</Button> */}
                        </DialogActions>
                    </Grid>
                    <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button onClick={handlePrint} color="primary" variant="contained">Print</Button>
                        </DialogActions>
                    </Grid>
                    {/* <Grid xs={4} lg={4}>
                        <DialogActions>
                            <Button color="primary" onClick={sendBillToWhatsApp} variant="contained">WhatsApp</Button>
                        </DialogActions>
                    </Grid> */}
                </Grid>



            </Dialog>
        );
    };

    export default PrintBillDialog;
